import useSWR from 'swr';
import { PlayerGoalKeeperStatsFragment } from '@amf/shared/types/graphql';

const getCacheKey = (player: string) => () => {
  const params = new URLSearchParams({ player });
  return `/api/player/goalKeeper?${params.toString()}`;
};

function useGoalKeeperStats(player: string) {
  const { data, error } = useSWR<PlayerGoalKeeperStatsFragment[]>(getCacheKey(player));
  return {
    error,
    stats: data && Array.isArray(data) ? data : [],
    loading: !data && !error,
  };
}

export default useGoalKeeperStats;
